// WindowedDocumentViewer.tsx

import { useAppSelector } from 'src/store/store';

import DraggableWindow from 'src/components/draggable-window/draggable-window';
import DocumentViewer from './document-viewer';

interface Props {
  onClose: () => void;
}

export default function WindowedDocumentViewer({ onClose }: Props) {

  const documentViewerState = useAppSelector((state) => state.app.documentViewer);

  return (
    <DraggableWindow
      onClose={onClose}
      title={documentViewerState.title}
      url={documentViewerState.fileUrl}
    >
      <DocumentViewer fileUrl={documentViewerState.fileUrl as string} />
    </DraggableWindow>
  );
}